import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Autocomplete, Box, TextField } from '@mui/material';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { BoilerAdapter } from 'z3k-parser/model/z3k-config/06-boiler-adapter';
export const SelectModelBoiler = (props) => {
    const { nextBoard, setDataSelectSettings, dataSelectSettings, typeDeviceForMasterSettings, } = props;
    const flagSelect = useRef({ boiler_model: false, boiler_adapter: false });
    const boiler_models = useAppSelector((state) => state.boiler_models.data?.boiler_models) ?? [];
    const arrModelBoiler = useMemo(() => typeDeviceForMasterSettings === 'ZOTA'
        ? boiler_models.filter((model) => model.group === 'ZOTA')
        : boiler_models, [typeDeviceForMasterSettings, boiler_models]);
    const getOptionLabel = useCallback((option) => option.text, []);
    const onAutocompleteChangeBoilerModel = useCallback((value) => {
        setDataSelectSettings({ ...dataSelectSettings, boiler_model: value });
        flagSelect.current = { ...flagSelect.current, boiler_model: true };
    }, [flagSelect.current]);
    const onAutocompleteChangeTypeBoilerAdapter = useCallback((value) => {
        setDataSelectSettings({ ...dataSelectSettings, boiler_adapter: value });
        flagSelect.current = { ...flagSelect.current, boiler_adapter: true };
    }, [flagSelect.current]);
    const isOptionEqualToValue = useCallback((option, value) => option == value, []);
    useEffect(() => {
        if (typeDeviceForMasterSettings === 'ZOTA' && flagSelect.current.boiler_model) {
            setTimeout(() => {
                nextBoard();
            }, 500);
        }
        if (typeDeviceForMasterSettings === 'SMART' &&
            flagSelect.current.boiler_model &&
            flagSelect.current.boiler_adapter) {
            setTimeout(() => {
                nextBoard();
            }, 500);
        }
    }, [dataSelectSettings]);
    return (_jsxs(Box, { sx: { display: 'flex', flexDirection: 'column' }, children: [_jsx(Autocomplete, { options: arrModelBoiler, groupBy: (arrModelBoiler) => arrModelBoiler.group, getOptionLabel: getOptionLabel, isOptionEqualToValue: isOptionEqualToValue, onChange: (_, value) => onAutocompleteChangeBoilerModel(value), sx: { width: isMediumUI() ? 400 : '100%', padding: '20px' }, renderInput: (params) => (_jsx(TextField, { variant: "standard", ...params, placeholder: 'Выберите модель котла' })) }), typeDeviceForMasterSettings === 'SMART' && (_jsx(Autocomplete, { options: BoilerAdapter.TypeOptions, getOptionLabel: getOptionLabel, isOptionEqualToValue: isOptionEqualToValue, onChange: (_, value) => onAutocompleteChangeTypeBoilerAdapter(value), sx: { width: isMediumUI() ? 400 : '100%', padding: '20px' }, renderInput: (params) => (_jsx(TextField, { variant: "standard", ...params, placeholder: 'Выберите тип протокола АЦШ' })) }))] }));
};
